<template>
  <div
    class="image-reviews-container product-page__image-reviews"
    :class="props.section.class"
  >
    <sib-carousel :items="items" :options="carouselOptions">
      <template #default="{ item }">
        <div class="image-reviews">
          <div class="user-profile-container">
            <div class="user-profile">
              <div class="user-profile__avatar" v-if="item.avatar">
                <sib-image
                  :src="item.avatar"
                  :alt="item.name"
                  :width="50"
                  :height="50"
                  :sources="[{ size: 100 }]"
                >
                </sib-image>
              </div>

              <div class="user-profile__info">
                <h5 class="user-profile__name" v-if="item.name">
                  <span>{{ item.name }}</span>
                </h5>
                <h5 class="image-review__title" v-if="item.title">
                  {{ item.title }}
                </h5>
              </div>
            </div>
          </div>
          <sib-image v-bind="item"></sib-image>
          <div class="image-reviews__icons">
            <HeartIcon class="heart-icon"></HeartIcon>
            <MessageIcon></MessageIcon>
          </div>
          <div
            class="image-reviews__content"
            v-if="item.reivew"
            v-html="item.reivew"
          ></div>
          <div class="image-reviews__time" v-if="item.time">
            <b>{{ item.time }}</b>
          </div>
        </div>
      </template>
    </sib-carousel>
  </div>
</template>

<script lang="ts" setup>
import { CarouselOptions } from '@/types'
import { computed } from 'vue'
import HeartIcon from '@/assets/images/icons/icon-heart.svg'
import MessageIcon from '@/assets/images/icons/icon-message.svg'

interface ImageReviewProps {
  section: any
}

const props = withDefaults(defineProps<ImageReviewProps>(), {})

const carouselOptions: CarouselOptions = {
  center: false,
}

const items = computed(() => {
  return props.section?.items.map((item) => {
    return {
      width: 640,
      height: 640,
      src: item.image,
      alt: item.title || '',
      title: item.title || '',
      loading: 'lazy',
      avatar: item.avatar,
      name: item.name,
      time: item.time,
      reivew: item.reivew,
      sources: [
        {
          size: 160,
        },
        {
          size: 200,
          media: 361,
        },
        {
          size: 250,
          media: 576,
        },
        {
          size: 190,
          media: 768,
        },
        {
          size: 280,
          media: 992,
        },
        {
          size: 300,
          media: 1400,
        },
      ],
      generateSrcSet: true,
    }
  })
})
</script>

<style lang="scss">
.product-page__image-reviews {
  .image-reviews-title {
    font-size: 22px;
    @include media-md-up {
      font-size: 2rem;
    }
  }
  .carousel {
    --carousel-slide-width: 100%;
    &__slide {
      font-size: 1rem;
      margin-right: 1em;
      overflow: hidden;
    }
    &__button.is-prev,
    &__button.is-next {
      background: #fff;
      color: var(--text-color-primary);
      border-radius: 50%;
      svg {
        width: 1rem;
      }
    }
    @include media-sm-up {
      --carousel-slide-width: calc((100% - 1em) / 2);
    }
    @include media-md-up {
      --carousel-slide-width: calc((100% - 2em) / 3);
    }
    @include media-xl-up {
      --carousel-slide-width: calc((100% - 3em) / 4);
    }
    @include media-xxl-up {
      --carousel-slide-width: calc((100% - 4em) / 5);
    }
    image {
      width: 100%;
      border-radius: var(--border-radius-large);
      margin: auto;
    }
  }
  .image-reviews {
    padding: 1rem;
    background-color: #f7f7f7;
    position: relative;
    border-radius: var(--border-radius-large);
    height: 100%;
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 0.75rem;
  }
  .user-profile {
    display: flex;
    gap: 1rem;
    overflow: hidden;
    &-container {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }
    &__avatar {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 40px;
      aspect-ratio: 1;
      img {
        border-radius: 50%;
      }
    }
    &__info {
      display: flex;
      flex-direction: column;
      justify-content: space-around;
    }
    &__name,
    .image-review__title {
      margin: 0;
      line-height: 1;
    }
    &__name {
      font-size: 14px;
      display: flex;
      align-items: center;
      gap: 0.25rem;
    }
  }
  .image-reviews__content {
    flex: 1;
  }
  .image-reviews__icons {
    display: flex;
    gap: 0.5rem;
    svg {
      width: 22px;
      height: 22px;
    }
    .heart-icon {
      fill: var(--color-secondary);
    }
  }
}
</style>
